import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useAuthStore from '@/store/authStore';
import Logo from '@/components/ui/Logo';
import Input from '@/components/ui/Input';
import Button from '@/components/ui/Button';
import LanguageSwitcher from '@/components/ui/LanguageSwitcher';
import styles from '../Login/Login.module.css';

export default function ResetPassword() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const resetPassword = useAuthStore((s) => s.resetPassword);

  const email = params.get('email') || '';
  const [code, setCode] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!/^\d{6}$/.test(code)) {
      setError(t('auth.codeInvalid'));
      return;
    }
    if (password.length < 6) {
      setError(t('auth.passwordShort'));
      return;
    }
    setLoading(true);
    try {
      const user = await resetPassword({ email, code, password });
      navigate(user.role === 'admin' ? '/admin' : '/trainer');
    } catch (err) {
      setError(err.message || t('auth.invalidCredentials'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.page}>
      <div className={styles.lang}>
        <LanguageSwitcher />
      </div>
      <form className={styles.card} onSubmit={handleSubmit}>
        <Logo size={40} />
        <p className={styles.tagline}>{email ? t('auth.resetSubtitle', { email }) : t('auth.forgotSubtitle')}</p>

        <Input
          id="code"
          label={t('auth.code')}
          value={code}
          onChange={(e) => setCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
          placeholder="000000"
          inputMode="numeric"
          required
        />
        <Input
          id="password"
          type="password"
          label={t('auth.newPassword')}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="••••••••"
          required
        />

        {error && <div className={styles.error}>{error}</div>}

        <Button type="submit" fullWidth loading={loading}>
          {t('auth.resetTitle')}
        </Button>

        <p className={styles.footer}>
          <button type="button" className={styles.linkMuted} onClick={() => navigate('/login')}>
            {t('auth.signIn')}
          </button>
        </p>
      </form>
    </div>
  );
}
